// generated from samples

import { z } from "zod/v4";
import { triggerFiltersGetSchema } from "./triggerFiltersGetSchema";

export const performedOrderPlacedTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::PerformedOrderPlaced"),
  is_any_order: z.boolean(),
  product_key: z.string().nullable().optional(),
  product_value: z.string().nullable().optional(),
  filter_description: z.string().optional(),
  filters: triggerFiltersGetSchema.optional(),
});
